import React, {Component} from 'react';
import {NavBar,Toast,Modal} from 'antd-mobile';
import './index.less';
import {dispatchOrderlist,closeOrder} from "../../../service/shuntService";
import {connect} from "react-redux";
import moment from 'moment';
const noPassenger = require('../../../common/image/noRider.png');
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class Dispatch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dispatch:1,//传递到发单界面，控制下面的确认发单状态，1代表是派单调度
            data:[],
            showModal:false,
            id:'',
        };
    }

    componentDidMount() {
        this.getDispatchListData();

    }
    //提示modal
    modalShow=(id)=>{
        this.setState({
            showModal:true,
            id:id
        })
    };
     //关闭接口
    delete = () =>{
        let params = {
            "token": this.props.userInfo.token,
            "data":{
                "shuntOrderCombinationId":this.state.id,
                "closeType": 2
            }
         };
         closeOrder(params)
             .then((res) => {
                 console.log(res)
                 if (res.data.code === '0000') {
                    Toast.info('关闭成功');
                    this.getDispatchListData();
                 }
                 else if (res.data.code === '1401') {
                    document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                 }
                 else {
                     Toast.info(res.data.msg);
                 }
             }).catch(function (error) {
             console.log(error);
         });
    };
    
    getDispatchListData=()=>{
        let params = {
            token: this.props.userInfo.token,
            data:{
                "pageSize": 100,
                "pageNum": 1,
                "dispacherType":'1'
            }
        };
        dispatchOrderlist(params)
            .then((res) => {
                console.log(res)
                if (res.data.code === '0000') {
                    this.setState({
                    data:res.data.data.list
                    })
                }
                else if (res.data.code === '1401') {
                    document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                }
                else {
                    Toast.info(res.data.msg);
                }
            }).catch(function (error) {
            console.log(error);
        });
    };
    goPage=(i)=>{
        let data = this.state.data;
        let billView =[];
        billView.push(
            data[i]
        )
        let refuse = data[i].denyCount;
        this.props.history.push('/billView',{dispatchData:billView,dispatch:this.state.dispatch,refuse:refuse})
    };
    render() {
        return (
            <div className="dispatch">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()}></i>}
                >派单调度</NavBar>
            {
                this.state.data.length > 0 ?
                    (this.state.data.map((res,i) => (
                        <div className="cardBox" key={i}>
                            <div className="header">
                                <div><span>订单号</span>{res.orderaNum}</div>
                                <div onClick={()=>this.modalShow(res.shuntConbinationId)}>关闭订单</div>
                            </div>
                            <div className="body">
                            {
                                this.state.data[i].orderDetails ? 
                                    this.state.data[i].orderDetails.map((res,i)=>(
                                        <div className="location" key={i}>
                                            <div className="shift">
                                                <span>{res.shiftName}</span>
                                                <span>行程时间：{res.startTime}</span>
                                            </div>
                                            {res.orderType == '送' ? <div><i className="icon iconfont icondaixiadanchufadi"></i>{res.vicinageStationName}</div> :null}
                                            <div><i className={res.orderType == '接' ? 'icon iconfont icondaixiadanchufadi' : 'icon iconfont icondaixiadanmudedi'}></i>{res.address}</div>
                                            {res.orderType == '接' ? <div><i className="icon iconfont icondaixiadanmudedi"></i>{res.vicinageStationName}</div> :null}
                                        </div>
                                        
                                    )):null
                            }
                            <div className="startTime">{moment(res.estimatedTiemOfDeparture).format("YYYY-MM-DD HH:mm:ss")}<span style={{color:"#616372"}}>￥{res.price}</span><span style={{color:"#616372"}}>人数：{res.peopleNum}人</span></div>
                            </div>
                            <div className="footer">
                                <div>
                                    {res.denyCount > 0 ? 
                                        <span style={{color:"#9A9B9B"}}>已拒单 <span>{res.denyCount}次</span></span>
                                        : null
                                    }
                                
                                </div>
                                <div onClick={()=>this.goPage(i)}>派单</div>
                            </div>
                        </div>
                    ))):(
                            <div className="noData">
                                <img src={noPassenger}/>
                                <p>暂无待派单数据</p>
                            </div>
                        )
            }
                
            <Modal
                className="combineBillViewModal"
                visible={this.state.showModal}
                transparent
                maskClosable={false}
                footer={[{ text: '取消', onPress: () => { this.setState({showModal:!this.state.showModal}); } },{ text: '确定', onPress: () => { this.setState({showModal:!this.state.showModal});this.delete() } }]}
            >
                <div className="modalTitle">
                    <div>是否确认关闭？</div>
                    <div>关闭订单乘客将变为不分流</div>
                </div>
            </Modal>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/CityService/Dispatch/index.js